export default "__VITE_ASSET__B9i27yMm__"